module.exports = __webpack_public_path__ + "img/tick_gray.72ab363c.svg";